// There a couple circumstances where storage doesn't work
// so we're going to make it in memory when we don't have
// access to local storage

let localStorageChecked = false;
let localStorageWorking = false;

const checkLocalStorage = () => {
  if (typeof window === 'undefined' || !window.localStorage) return false;
  try {
    // we don't check clear because that would be destructive in this case
    localStorage.setItem('test', 'value');
    const value = localStorage.getItem('test');
    localStorage.removeItem('test');
    return value === 'value';
  } catch {
    return false;
  }
};

const getMockedLocalStorage = (): Storage => {
  const map = new Map<string, string>();

  return {
    getItem: (key) => map.get(key) ?? null, // null is what local storage returns over undefined
    setItem: (key, value) => {
      map.set(key, value);
    },
    removeItem: (key) => {
      map.delete(key);
    },
    clear: () => {
      map.clear();
    },
    key: (index) => {
      const keys = Array.from(map.keys());
      return keys[index] ?? null;
    },
    get length() {
      return map.size;
    },
  };
};

const mockedLocalStorage = getMockedLocalStorage();

const getStorage = () => {
  // only want to check if local storage works once
  if (!localStorageChecked) {
    localStorageWorking = checkLocalStorage();
    localStorageChecked = true;
  }

  return localStorageWorking ? localStorage : mockedLocalStorage;
};

// export an object that has the same interface as localStorage
export const storage: Storage = {
  setItem: (key, value) => getStorage().setItem(key, value),
  getItem: (key) => getStorage().getItem(key),
  removeItem: (key) => getStorage().removeItem(key),
  clear: () => getStorage().clear(),
  key: (index) => getStorage().key(index),
  get length() {
    return getStorage().length;
  },
};
